// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddToCartTrackingController from "./add_to_cart_tracking_controller"
application.register("add-to-cart-tracking", AddToCartTrackingController)

import AddressController from "./address_controller"
application.register("address", AddressController)

import ArtworkUploadController from "./artwork_upload_controller"
application.register("artwork-upload", ArtworkUploadController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import CartAnimateController from "./cart_animate_controller"
application.register("cart-animate", CartAnimateController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import CartTrackingController from "./cart_tracking_controller"
application.register("cart-tracking", CartTrackingController)

import CategoryTrackingController from "./category_tracking_controller"
application.register("category-tracking", CategoryTrackingController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import CopyTextController from "./copy_text_controller"
application.register("copy-text", CopyTextController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import PaymentTrackingController from "./payment_tracking_controller"
application.register("payment-tracking", PaymentTrackingController)

import ProductTrackingController from "./product_tracking_controller"
application.register("product-tracking", ProductTrackingController)

import QuantityValidationController from "./quantity_validation_controller"
application.register("quantity-validation", QuantityValidationController)

import QuoteReviewController from "./quote_review_controller"
application.register("quote-review", QuoteReviewController)

import QuoteTrackingController from "./quote_tracking_controller"
application.register("quote-tracking", QuoteTrackingController)

import SearchTrackingController from "./search_tracking_controller"
application.register("search-tracking", SearchTrackingController)

import PriceRefreshController from "./price_refresh_controller"
application.register("price-refresh", PriceRefreshController)
